import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { Observable } from 'rxjs';
import { AddUserDialogComponent } from './add-user-dialog/add-user-dialog.component';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { UsersButtonRendererComponent } from 'projects/admin/src/lib/user-management/users-button-renderer/users-button-renderer.component';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { PlatformGroupRoleDto } from 'projects/shared/src/lib/models/PlatformGroupRoleDto';
import { AgGridUsersSettings } from './AgGridUsersSettings';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { UsersDemoflagRendererComponent } from './users-demoflag-renderer/users-demoflag-renderer.component';
import { UserProfileService } from 'projects/shared/src/lib/services/user-profile.service';
import { UserProfileForCreation } from 'projects/shared/src/lib/models/UserProfileForCreation';
import { Router } from '@angular/router';
import { UserProfile } from 'projects/shared/src/lib/models/UserProfile';

@Component({
  selector: 'user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserManagementComponent implements OnInit {

  _addUserRole!:string;
  _db!:string;
  _targetIsTenantDB = true;

  isAuthenticated$!: Observable<boolean>;
  isAuthenticated!: boolean;

  rowData: UserDto[] = [];
  userData: UserDto[] = [];

  allProfiles: UserProfile[] = [];
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridUsersSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  //resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  isAddPossible = true;
  noUser = false;
  count = 0;


  _userRoles:string[] = [];

  constructor(public dialog: MatDialog,
    // private router: Router,
    private accountService: AccountService,
    private oauthService: OAuthServiceService,
    private tenantService:TenantService,
    private userProfileService: UserProfileService,
    public translate: TranslateService,
    private notificationService: NotificationService) { 

      // this.router.routeReuseStrategy.shouldReuseRoute = () => {
      //   return false;
      // };
    }

  ngOnInit(): void {
    var self = this;

    this._targetIsTenantDB = this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation;
    
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          //self._userRoles = data.role as Array<string>;
          let userRoles = data.role as Array<string>;
          userRoles.forEach((role: string) =>{
            if (role != "MANAGE_USERS" && role != "CREATE_USER" &&  role != "MANAGE_PROJECTS" && role != "CREATE_PROJECT") self._userRoles.push(role);
          })
          //console.log("------> user-management self.userRoles (userData): ", self._userRoles)
        }
      }
    });    
    let tenant = this.tenantService.currentTenantName;
    // console.log("-------> user-management tenant = ", tenant)
    this.tenantService.getToken(tenant).subscribe({
      next: (token) => {
        //self._userRoles = this.tenantService.getTenantRoles(token);
        var tenantRoles = this.tenantService.getTenantRoles(token);
        tenantRoles.forEach((role: string)=> {
          if (role != "" && !this._userRoles.includes(role)) self._userRoles.push(role);
        });
        //console.log("------> user-management self.userRoles (token): ", self._userRoles)
        //this.work(); // dann funktioniert F5 nicht!
      }
    });
    this.work();
  }

  work() {
    let profileMap = new Map<string, UserProfileForCreation>();
    this.isAuthenticated$ = this.oauthService.isLoggedIn;
    this.isAuthenticated$.subscribe({
      next: (isAuthenticated) => {
        this.isAuthenticated = isAuthenticated;
      }
    });

    // this.tenantService.getUserTenant().subscribe({
    //   next: (tenancy) => {
    //     if(tenancy === null) {
    //       localStorage.setItem('tenant-db', String(null));
    //     }
    //     else{
    //       localStorage.setItem('tenant-db', tenancy.tenantName);
    //     }
    //   }
    // })

    this.filter = new GenericFilter();
    //console.log("-------> user management _userRoles = ", this._userRoles)
    this.aggridSettings = new AgGridUsersSettings(this.translate, this._userRoles.includes('MANAGE_USERS') || this._userRoles.includes('admin'));
    this.frameworkComponents = {buttonRenderer: UsersButtonRendererComponent, flagRenderer: UsersDemoflagRendererComponent}
    this.gridOptions = this.aggridSettings.agGridUsersSettings;

    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {

        this.filter.className = 'UserProfile';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        {
          let db:string = this.tenantService.currentTenantName;
          // console.log("--------> user-management getTenantUser db = ", db);
          if (db != this.tenantService.SystemManagerAbbreviation) {

            this.tenantService.getTenantUsers(db, this.filter).subscribe({
              next: (users) => {
                let count = 0;
                let userIds:string[] = [];
                users.forEach((user: UserDto)=>{if (user.emailConfirmed) userIds.push(user.id)});
                // console.log("-------> user ids = ", userIds);
                this.userData = [];
                if (users.length > 0) {

                  // console.log("------> vor getUsersByIds ");
                  this.userProfileService.getUsersByIds(userIds).subscribe({
                    next:(userProfiles) => {       
                      // console.log("------> userProfiles", userProfiles)
                      userProfiles.forEach((profile: UserProfileForCreation) =>{
                        // console.log("-----> profile = ", profile)
                        profileMap.set(profile.id, profile);
                      });
                      // console.log("------> profileMap = ", profileMap);
                      users.forEach((user: UserDto) => {
                        //console.log("user confirmed = ", user.emailConfirmed)
                        if (!user.emailConfirmed) {
                          count++;
                          //user.userName = user.userName + " (not confirmed)"; 
                          user.lastName = "(not confirmed)";
                          user.firstName = "";
                          this.userData.push(user);
                          if (count == users.length) {
                            //console.log(">>>>>>>>>>>>>>>>>>>>> UserData = ",this.userData)
                            this.rowData = this.userData.sort((a, b) => (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 : 0));
                            //this.rowData = this.userData.sort();
                            //this.rowData = this.userData;
                            //console.log(">>>>>>>>>>>>>>>>>>>>> userData.length = ", this.userData.length)
      
                            this.rowData = this.rowData.slice(params.startRow, params.endRow);
                            //console.log(">>>>>>>>>>>>>>>>>>>>> rowData.length = ", this.rowData.length)
                            let lastRow = -1;
                
                            if (users.length <= params.endRow) {
                              lastRow = users.length;
                            }
                            //console.log(">>>>>>>>>>>>>>>>>>>>> lastRow = ",lastRow)
                            params.successCallback(this.rowData, lastRow);
                            this.isLoadingResults = false;
                            this.isRateLimitReached = false;
                            //this.resultsLength = this.rowData.length;
                
                            this.gridApi.hideOverlay();
                          
                            //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERSRETRIEVED"]}`);
                          }
                        } else {
                          count++;
                          // aus profileMap wird mit userId das userProfile gelesen und die Namen aus Claims übernommen
                          var profile = profileMap.get(user.id);
                          //console.log("profile = ", profile)
                          user.userName = (profile) ? profile.fullName : "";
                          user.firstName = (profile) ? profile.givenName : "";
                          user.lastName = (profile) ? profile.familyName : "";
                          //user.phoneNumber = (profile) ? profile.phoneNumber : ""; // phonenumber nicht in Claims! Daher leer
                          this.userData.push(user);
                          //console.log(">>>>>>>>>>>>>>>>>>>>> UserData = ",this.userData)
                          if (count == users.length) {
                            this.rowData = this.userData.sort((a, b) => (a.lastName+a.firstName > b.lastName+b.firstName) ? 1 : ((b.lastName+b.firstName > a.lastName+a.firstName) ? -1 : 0));
                            //this.rowData = this.userData.sort();
                            //this.rowData = this.userData;
  
                            this.rowData = this.rowData.slice(params.startRow, params.endRow);
                            let lastRow = -1;
                
                            if (users.length <= params.endRow) {
                              lastRow = users.length;
                            }
                            params.successCallback(this.rowData, lastRow);
                            this.isLoadingResults = false;
                            this.isRateLimitReached = false;
                            //this.resultsLength = this.rowData.length;
                
                            this.gridApi.hideOverlay();
                          
                            //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERSRETRIEVED"]}`);
                          }
                      // this.userProfileService.getUserById(user.id).subscribe({
                      //        next:(userProfile: UserProfileForCreation) => {       
                      //         count++;
                      //         user.userName = userProfile.fullName;
                      //         user.firstName = userProfile.givenName;
                      //         user.lastName = userProfile.familyName;
                      //         user.phoneNumber = userProfile.phoneNumber;
                      //         this.userData.push(user);
                      //         console.log(">>>>>>>>>>>>>>>>>>>>> UserData = ",this.userData)
                      //         if (count == users.length) {
                      //           console.log(">>>>>>>>>>>>>>>>>>>>> UserData = ",this.userData)
                      //           this.rowData = this.userData.sort((a, b) => (a.lastName+a.firstName > b.lastName+b.firstName) ? 1 : ((b.lastName+b.firstName > a.lastName+a.firstName) ? -1 : 0));
                      //           //this.rowData = this.userData.sort();
                      //           //this.rowData = this.userData;
                      //           console.log(">>>>>>>>>>>>>>>>>>>>> userData = ", this.userData)
      
                      //           this.rowData = this.rowData.slice(params.startRow, params.endRow);
                      //           console.log(">>>>>>>>>>>>>>>>>>>>> rowData = ", this.rowData)
                      //           let lastRow = -1;
                    
                      //           if (users.length <= params.endRow) {
                      //             lastRow = users.length;
                      //           }
                      //           console.log(">>>>>>>>>>>>>>>>>>>>> lastRow = ",lastRow)
                      //           params.successCallback(this.rowData, lastRow);
                      //           this.isLoadingResults = false;
                      //           this.isRateLimitReached = false;
                      //           //this.resultsLength = this.rowData.length;
                    
                      //           this.gridApi.hideOverlay();
                              
                      //           //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERSRETRIEVED"]}`);
                      //         }
                          //    }
                          //  });
                        }
                      });
                    }
                  });


                } else {
                  // this.noUser = true;
                  // this.isLoadingResults = false;
                  // this.isRateLimitReached = false;
                  // this.rowData = users.slice(this.filter.startRow, this.filter.endRow);
                  this.notificationService.info(`${this.translate.data["INFO"]}`, "Kein Benutzer vorhanden!")
                  let lastRow = -1;
    
                  // if (this.rowData.length <= this.filter.endRow) {
                  //   lastRow = this.rowData.length;
                  // }
                  if (users.length <= params.endRow) {
                    lastRow = users.length;
                  }
                  params.successCallback(this.rowData, lastRow);
                  // Flip flag to show that loading has finished.
                  this.isLoadingResults = false;
                  this.isRateLimitReached = false;
                  //this.resultsLength = this.rowData.length;
      
                  this.gridApi.hideOverlay();  

                }
              },
              error: (error: any) => {
                this.isLoadingResults = false;
                this.isRateLimitReached = true;
                this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERRETRIVALERROR"]}`)
              }
            });
          }
          else { // "SM"
            this.accountService.loadUsers(this.filter).subscribe({
              next: (users) => {
                users.forEach((user: UserDto) => {
                  console.log("user confirmed = ", user.emailConfirmed)
                  if (!user.emailConfirmed) {
                    //user.userName = user.userName + " (not confirmed)"; 
                    user.userName = "(not confirmed)"; 
                  }
                });
      
                this.rowData = users;
                this.rowData = this.rowData.slice(params.startRow, params.endRow);
                let lastRow = -1;
    
                if (users.length <= params.endRow) {
                  lastRow = users.length;
                }
                params.successCallback(this.rowData, lastRow);
                this.isLoadingResults = false;
                this.isRateLimitReached = false;
                //this.resultsLength = this.rowData.length;
    
                this.gridApi.hideOverlay();
              
                //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERSRETRIEVED"]}`);
              },
              error: (error: any) => {
                this.isLoadingResults = false;
                this.isRateLimitReached = true;
                this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERRETRIVALERROR"]}`)
              }
            });
          }
        }       
      }
    };
  }

 
  onGridReady(params: any) {
    this.gridApi = params.api;    
    this.gridApi.sizeColumnsToFit();    
    this.gridApi.setDatasource(this.ds)
  }

  addUser() {
    console.log("-----> user-management.addUser()")

    const dialogRef = this.dialog.open(AddUserDialogComponent, { width: '800px', data: this.noUser });
      dialogRef.afterClosed().subscribe((result: any) => { 

        // console.log("-----> user-management.addUser(): result = ", result)
        if (result !== undefined) {
          let userDto:UserDto = result.userDto;        
          // result.subSquirrels.forEach((role:PlatformGroupRoleDto) => {
          //  userDto.userRoles.push(role);
          // });
  
          userDto.tenant = result.userDto.tenant;
          // console.log("-----> user-management.addUser(): userDto = ",userDto)
          // console.log("-----> user-management.addUser(): tenantID = ",this.tenantService.currentTenantId)
  
          this.accountService.createUser(userDto, this.tenantService.currentTenantName, this.tenantService.currentTenantId).subscribe({
            next: (user) => {
              this.rowData.splice(2, 0, user);
              this.rowData.push(user);            
              this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERADDED"]}`);
              // if(this.noUser) {
              //   console.log("----------------> user-management: no user before")
              //   //this.router.navigateByUrl('/' + this.tenantService.currentTenantName + '/manage-users'); funktioniert nicht!
              // }
              // else {
                this.gridApi.refreshInfiniteCache();
              // }

  
            },
            error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERADDEDERROR"]}`)
          });
      }
    },
      //error
    );
  }
}



